<template>
  <div ref="mapContainer" style="height: 1000px; width: 100%;"></div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.heat";

export default {
  name: "CustomerHeatMap",
  data: () => ({
    locationspath: "/1.0/front/location/statistics/locations",
    map: null,
  }),
  mounted() {
    this.map = L.map(this.$refs.mapContainer).setView([62.24, 25.72], 6);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
    }).addTo(this.map);

    this.$http
      .get(this.locationspath)
      .then((response) => {
        if (response.status == 200) {
          const points = response.data.locations.map((loc) => [loc.lat, loc.lng, 1]);
          L.heatLayer(points, { radius: 25, maxZoom: 12 }).addTo(this.map);
        } else if (response.status == 401) {
          this.$root.$emit("session_failed");
        }
      })
      .catch((error) => {
        this.$root.$emit("session_failed");
        return error;
      });
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
    }
  },
};
</script>
